/// <amd-module name="VSS/Features/ReduxDirectory/components/DirectoryContentView/ConnectedDirectoryContentView" />
// @ts-ignore Unused import is needed for the connect() call
import * as React from "react";

import { connect } from "react-redux";
import { DirectoryContentView } from "VSS/Features/Directory/DirectoryContentView";
import { IDirectoryViewState } from "Contracts";
import { IDirectoryArtifact } from "VSS/Features/Directory/DirectoryContracts";
import { DirectoryActions } from "../../Redux/DirectoryActions";
import { FavoriteActions } from "../../Redux/Favorites/FavoriteActions";
import {
    isAllSectionLoading,
    isNavigating,
    isFilterVisible,
    getFavoriteMap,
    createInstanceSelectors,
    getExceptionInfo,
    getTtiReadyState
} from "../../Redux/DirectorySelectors";
import { isFilterActive } from "VSS/Redux/Deprecated/HubViewState";
import { TTIMonitorActions } from "VSS/Redux/Modules/TTIMonitor";
import { IDirectoryContentViewOwnProps, IDirectoryContentViewMappedProps } from "./ConnectedDirectoryContentView.Props";

const Actions = {
    markTti: TTIMonitorActions.markTTI,
    navigateToUrl: DirectoryActions.navigateToUrl,
    toggleFavorite: FavoriteActions.toggleFavorite,
    toggleGroup: DirectoryActions.rowGroupToggled,
    toggleFilter: DirectoryActions.toggleFilter
};

function mapStateToProps<T extends IDirectoryArtifact>(
    state: IDirectoryViewState<T>,
    ownProps: IDirectoryContentViewOwnProps<T>
): IDirectoryContentViewMappedProps<T> {
    const memoizedSelectors = createInstanceSelectors();

    return {
        favorites: getFavoriteMap(state),
        directoryRows: memoizedSelectors.getDirectoryRows(state, ownProps),
        isFilterActive: isFilterActive(state),
        isFilterVisible: isFilterVisible(state),
        isAllSectionLoading: isAllSectionLoading(state),
        isNavigating: isNavigating(state),
        exceptionInfo: getExceptionInfo(state),
        readyToMarkTti: getTtiReadyState(state)
    };
}

export const ConnectedDirectoryContentView = connect(
    mapStateToProps,
    Actions
)(DirectoryContentView);
